export default {"src":"/_next/static/media/linkdn.0876150c.svg","height":23,"width":95,"blurWidth":0,"blurHeight":0};